import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.js';
import '../parents/AllParents.css';

const ViewParent = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem('jwtToken');
  const { userInfo } = useAuth();
  const role = userInfo?.role;

  const [parent, setParent] = useState(null);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (role === 'super_admin') {
          const locRes = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/location/allLocations`,
            {
              headers: {
                Authorization: `Bearer ${token}`              },
            }
          );
          setLocations(locRes.data.data || []);
        } else {
          setLocations([]);
        }

        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/parent/getparentbyid/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        setParent(res.data.data);
      } catch (err) {
        console.error('Error fetching parent', err);
        setError('Kon ouder niet laden.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, role, token]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-danger">{error}</p>;
  if (!parent) return <p>Geen data.</p>;

  return (
    <div className="bg-white p-4 view-parent">
      <h2 className="text-center">Bekijk Ouder</h2>
      <hr className="separator" />

      <div className="row mb-3">
        <div className="col-md-6">
          <label>Voornaam</label>
          <input
            type="text"
            className="form-control"
            value={parent.firstname || ''}
            disabled
          />
        </div>
        <div className="col-md-6">
          <label>Achternaam</label>
          <input
            type="text"
            className="form-control"
            value={parent.lastname || ''}
            disabled
          />
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-6">
          <label>Email</label>
          <input
            type="email"
            className="form-control"
            value={parent.email || ''}
            disabled
          />
        </div>
        <div className="col-md-6">
          <label>Mobiel</label>
          <input
            type="text"
            className="form-control"
            value={parent.mobile || ''}
            disabled
          />
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-6">
          <label>Opleidingsniveau</label>
          <input
            type="text"
            className="form-control"
            value={parent.beroep || ''}
            disabled
          />
        </div>
       
        <div className="col-md-3 d-flex align-items-center">
          <div className="form-check mt-4">
            <input
              className="form-check-input"
              type="checkbox"
              checked={!!parent.iscontactperson}
              disabled
            />
            <label className="form-check-label">Contactpersoon</label>
          </div>
        </div>
      </div>

      {role === 'super_admin' && (
        <div className="mb-3">
          <label>Locatie</label>
          <select className="form-select" value={parent.location_id || ''} disabled>
            <option value="">-- Geen locatie --</option>
            {locations.map((loc) => (
              <option key={loc.location_id} value={loc.location_id}>
                {loc.location_name}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="d-flex justify-content-between mt-4">
        <button className="btn btn-secondary" onClick={() => navigate('/ouders')}>
          Terug
        </button>
      </div>
    </div>
  );
};

export default ViewParent;